/**
 * Canonical workflow-dispatcher step names, shared between the API's step registry
 * (`apps/api/src/workflows/registry.ts`) and the CDK Step Functions wiring
 * (`infra/lib/constructs/workflows.ts`) — the same cross-package trick as
 * `dunning.ts`, so a renamed or typo'd step name fails typecheck in both places
 * instead of throwing "unknown step" at runtime in prod. An enum (rather than a
 * plain string union) means every call site references `WorkflowStep.X` instead of
 * a raw string literal, so a typo can't silently produce a new, valid-looking value.
 */
export enum WorkflowStep {
  NotifyPropertyCreated = 'NotifyPropertyCreated',
  GenerateReviewTask = 'GenerateReviewTask',
  CompleteReviewTask = 'CompleteReviewTask',
  UpdateSubscription = 'UpdateSubscription',
  NotifyOwner = 'NotifyOwner',
  CloseReviewTask = 'CloseReviewTask',
  CreateRetryTask = 'CreateRetryTask',
  ArchiveRejectedMedia = 'ArchiveRejectedMedia',
  NotifyMonitoringStopped = 'NotifyMonitoringStopped',
  DeletePropertyMedia = 'DeletePropertyMedia',
  NotifyPropertyArchived = 'NotifyPropertyArchived',
  ResolveContext = 'ResolveContext',
  RecordPayment = 'RecordPayment',
  ActivateOrRenew = 'ActivateOrRenew',
  CreateMonitoringTaskPayment = 'CreateMonitoringTaskPayment',
  NotifyOwnerPayment = 'NotifyOwnerPayment',
  MarkPastDue = 'MarkPastDue',
  NotifyPaymentFailed = 'NotifyPaymentFailed',
  MarkAuthenticated = 'MarkAuthenticated',
  CancelSubscription = 'CancelSubscription',
  NotifyCancelled = 'NotifyCancelled',
  MarkPaused = 'MarkPaused',
  MarkIgnoredPayment = 'MarkIgnoredPayment',
  MarkProcessed = 'MarkProcessed',
  MarkFailed = 'MarkFailed',
  SubscriptionActivated = 'SubscriptionActivated',
  CheckStillPastDue = 'CheckStillPastDue',
  NotifyDunningReminder = 'NotifyDunningReminder',
  SuspendSubscription = 'SuspendSubscription',
}
